/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_section_10_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date. Continued use of our services after changes constitutes acceptance of the updated policy.`)
};

const es_privacy_section_10_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podemos actualizar esta Política de Privacidad de vez en cuando. Te notificaremos de cualquier cambio publicando la nueva Política de Privacidad en esta página y actualizando la fecha de «Ultima actualización». El uso continuado de nuestros servicios después de los cambios constituye la aceptación de la política actualizada.`)
};

const de_privacy_section_10_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir können diese Datenschutzrichtlinie von Zeit zu Zeit aktualisieren. Wir werden Sie über Änderungen informieren, indem wir die neue Datenschutzrichtlinie auf dieser Seite veröffentlichen und das Datum der letzten Aktualisierung anpassen. Die fortgesetzte Nutzung unserer Dienste nach Änderungen stellt die Akzeptanz der aktualisierten Richtlinie dar.`)
};

const nl_privacy_section_10_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We kunnen dit privacybeleid van tijd tot tijd bijwerken. We zullen u op de hoogte stellen van wijzigingen door het nieuwe privacybeleid op deze pagina te plaatsen en de datum "Laatst bijgewerkt" bij te werken. Voortgezet gebruik van onze diensten na wijzigingen houdt aanvaarding van het bijgewerkte beleid in.`)
};

const fr_privacy_section_10_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous pouvons mettre à jour cette politique de confidentialité de temps en temps. Nous vous informerons de tout changement en publiant la nouvelle politique de confidentialité sur cette page et en mettant à jour la date de « Dernière mise à jour ». L’utilisation continue de nos services après les modifications constitue une acceptation de la politique mise à jour.`)
};

const it_privacy_section_10_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potremmo aggiornare questa Informativa sulla Privacy di tanto in tanto. Ti informeremo di eventuali modifiche pubblicando la nuova Informativa sulla Privacy su questa pagina e aggiornando la data dell’"Ultimo aggiornamento". L’uso continuato dei nostri servizi dopo le modifiche costituisce accettazione dell’informativa aggiornata.`)
};

const pt_br2_privacy_section_10_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podemos atualizar esta Política de Privacidade de tempos em tempos. Notificaremos você sobre quaisquer alterações publicando a nova Política de Privacidade nesta página e atualizando a data de “Última atualização”. O uso continuado de nossos serviços após alterações constitui aceitação da política atualizada.`)
};

const pt_privacy_section_10_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podemos atualizar esta Política de Privacidade periodicamente. Notificá-lo-emos de quaisquer alterações ao publicar a nova Política de Privacidade nesta página e ao atualizar a data de "Última atualização". A utilização continuada dos nossos serviços após as alterações constitui aceitação da política atualizada.`)
};

const ja_privacy_section_10_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このプライバシーポリシーは随時更新される場合があります。新しいプライバシーポリシーをこのページに掲載し、「最終更新」日を更新することでお知らせします。変更後もサービスを継続利用することは、更新されたポリシーへの同意とみなされます。`)
};

const zh_privacy_section_10_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们可能会不时更新本隐私政策。我们将通过在此页面发布新的隐私政策并更新“最后更新”日期来通知您任何变更。在变更后继续使用我们的服务即表示接受更新后的政策。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_section_10_text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_section_10_text(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_section_10_text", locale)
	if (locale === "en") return en_privacy_section_10_text(inputs)
	if (locale === "es") return es_privacy_section_10_text(inputs)
	if (locale === "de") return de_privacy_section_10_text(inputs)
	if (locale === "nl") return nl_privacy_section_10_text(inputs)
	if (locale === "fr") return fr_privacy_section_10_text(inputs)
	if (locale === "it") return it_privacy_section_10_text(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_section_10_text(inputs)
	if (locale === "pt") return pt_privacy_section_10_text(inputs)
	if (locale === "ja") return ja_privacy_section_10_text(inputs)
	return zh_privacy_section_10_text(inputs)
};